require('./sectionTemplateEditor.tpl.html');
require('./sectionTemplateEditorRepository.js');
require('./header/sectionTemplateEditorHeaderComponent.js');
require('./content/rule/sectionTemplateRuleController.js');
require('./content/properties/sectionTemplatePropertiesController.js');
require('./nav/sectionTemplateEditorNavComponent.js');

/*@ngInject*/
const SectionTemplateEditorController = function ($scope, $stateParams, sectionTemplateEditorModel, configurationConstant) {

    function init() {
        sectionTemplateEditorModel.buildSectionTemplate(parseInt($stateParams.sectionTemplateId));
    }

    $scope.$on('$destroy', function () {
        sectionTemplateEditorModel.reset(parseInt($stateParams.sectionTemplateId));
    });

    init();
};

angular.module('ums.configuration')
    .controller('sectionTemplateEditorController', SectionTemplateEditorController);
